import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Ariat',
    frontend: 'https://ariat.mybenefitsnow.com',
    apiHash: 'https://ariat.mybenefitsnow.com/api/1.0',
    api: '/api/2.0',
    modernised: true,
    authHeaders: {
        xServiceProvider: 'ariat-prod-frontend',
        'tenant-id': '3843e29c-ad40-4f3c-986d-8a069e31eec2',
        'consumer-id': '81187299-bc88-4ff7-84b3-2b6af3fecb9c',
    },
    commitSHA: 'f469aa1',
    provider: 'ariat-prod-frontend',
} as CONFIG; 
